const data = [
    {
        id: 0,
        alt: "project",
        image: "images/project16.png",
        webUrl: "https://bhagirathipickles.com/",
        gitUrl: "https://github.com/adarshsharma27",
    },
    {
        id: 2,
        alt: "project",
        image: "images/project1.png",
        webUrl: "https://clipboarden.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/clipboard",
    },
    {
        id: 3,
        alt: "project",
        image: "images/project3.png",
        webUrl: "https://iheadphones.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/headphoneswebsite",
    },
    {
        id: 4,
        alt: "project",
        image: "images/project4.png",
        webUrl: "https://darkenf.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/darkenfss",
    },
    {
        id: 5,
        alt: "project",
        image: "images/project5.png",
        webUrl: "https://adresort.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/adresort",
    },
    {
        id: 6,
        alt: "project",
        image: "images/project6.png",
        webUrl: "https://coecafe.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/coecafe",
    },
    {
        id: 7,
        alt: "project",
        image: "images/project7.png",
        webUrl: "https://insures.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/insure",
    },
    {
        id: 8,
        alt: "project",
        image: "images/project8.png",
        webUrl: "https://shortlys.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/shortly",
    },
    {
        id: 9,
        alt: "project",
        image: "images/project9.png",
        webUrl: "https://fylos.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/fylowebsite",
    },
    {
        id: 10,
        alt: "project",
        image: "images/project10.png",
        webUrl: "https://aparonevents.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/Events",
    },
    {
        id: 11,
        alt: "project",
        image: "images/project11.png",
        webUrl: "https://manage-b6e3e.web.app/",
        gitUrl: "https://github.com/adarshsharma27",
    },
    {
        id: 12,
        alt: "project",
        image: "images/project12.png",
        webUrl: "http://icakes.netlify.com/",
        gitUrl: "https://github.com/adarshsharma27/cakes",
    },
    {
        id: 13,
        alt: "project",
        image: "images/project13.png",
        webUrl: "https://smdashboard.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/socialmedia-dashboard",
    },
    {
        id: 14,
        alt: "project",
        image: "images/project14.png",
        webUrl: "https://jobslisting.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/joblisting",
    },
    {
        id: 15,
        alt: "project",
        image: "images/project15.png",
        webUrl: "https://smdashboard.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/socialmedia-dashboard",
    },
    {
        id: 16,
        alt: "project",
        image: "images/project2.png",
        webUrl: "https://huddless.netlify.app/",
        gitUrl: "https://github.com/adarshsharma27/huddle",
    },
];

export default data;
